import { useCallback, useEffect, useState } from "react"

export const StatusType = {
  CheckPrometheus: "check-prometheus",
  Hidden: "hidden",

  Active: "active",
  Recover: "recover",
  Maintain: "maintain",
  Failure: "failure",
};

export default function useData() {
  // prometheus section value:
  //      kavenegar
  //      db_firmware_versions
  //      auto_solo_devices
  //      auto_gw
  //      file_download

  // config file keys:
  //      kavenegar
  //      dbFirmwareVersions
  //      autoSoloDevices
  //      autoGw
  //      fileDownload

  const [loadedOnce, setLoadedOnce] = useState(false);

  const [kavenegar, setKavenegar] = useState({ status: StatusType.Hidden, lastTime: undefined });
  const [dbFirmwareVersions, setDBFirmwareVersions] = useState({ status: StatusType.Hidden, lastTime: undefined });
  const [autoSoloDevices, setAutoSoloDevices] = useState({ status: StatusType.Hidden, lastTime: undefined });
  const [autoGw, setAutoGw] = useState({ status: StatusType.Hidden, lastTime: undefined });
  const [fileDownload, setFileDownload] = useState({ status: StatusType.Hidden, lastTime: undefined });

  const issueUpdate = useCallback(() => {
    console.log("issueUpdate")
    const now = Date.now() / 1000 | 0;
    const lastQuarter = now - 60 * 15;

    const configUrl = '/appConfig.json'

    fetch(configUrl)
      .then(configRes => configRes.json())
      .then(
        (configResult) => {
          const prometheusAddress = configResult.prometheusAddress;
          const promUrl = `${prometheusAddress}/api/v1/query_range?query=hinava_status&start=${lastQuarter}&end=${now}&step=1`;
          fetch(promUrl)
            .then(promRes => promRes.json())
            .then(
              (promResult) => {
                setLoadedOnce(true);
                if (configResult.sources.kavenegar !== undefined) {
                  if (configResult.sources.kavenegar === StatusType.CheckPrometheus) {
                    setKavenegar(checkPrometheusResult(lastQuarter, now, 'kavenegar', promResult));
                  } else {
                    setKavenegar({ status: configResult.sources.kavenegar, lastTime: now });
                  }
                }
                if (configResult.sources.dbFirmwareVersions !== undefined) {
                  if (configResult.sources.dbFirmwareVersions === StatusType.CheckPrometheus) {
                    setDBFirmwareVersions(checkPrometheusResult(lastQuarter, now, 'db_firmware_versions', promResult));
                  } else {
                    setKavenegar({ status: configResult.sources.dbFirmwareVersions, lastTime: now });
                  }
                }
                if (configResult.sources.autoSoloDevices !== undefined) {
                  if (configResult.sources.autoSoloDevices === StatusType.CheckPrometheus) {
                    setAutoSoloDevices(checkPrometheusResult(lastQuarter, now, 'auto_solo_devices', promResult));
                  } else {
                    setKavenegar({ status: configResult.sources.autoSoloDevices, lastTime: now });
                  }
                }
                if (configResult.sources.autoGw !== undefined) {
                  if (configResult.sources.autoGw === StatusType.CheckPrometheus) {
                    setAutoGw(checkPrometheusResult(lastQuarter, now, 'auto_gw', promResult));
                  } else {
                    setKavenegar({ status: configResult.sources.autoGw, lastTime: now });
                  }
                }
                if (configResult.sources.fileDownload !== undefined) {
                  if (configResult.sources.fileDownload === StatusType.CheckPrometheus) {
                    setFileDownload(checkPrometheusResult(lastQuarter, now, 'file_download', promResult));
                  } else {
                    setKavenegar({ status: configResult.sources.fileDownload, lastTime: now });
                  }
                }
              },
              (error) => {
                console.log(error)
              }
            );
        },
        (error) => {
          console.log(error)
        }
      );
  }, []);

  useEffect(() => {
    issueUpdate()
    const id = setInterval(issueUpdate, 60000);

    return () => clearInterval(id);
  }, [issueUpdate]);

  return {
    loadedOnce,
    cards: {
      kavenegar,
      dbFirmwareVersions,
      autoSoloDevices,
      autoGw,
      fileDownload
    },
  };
}

function checkPrometheusResult(startTime, endTime, section, response) {
  if ((response["status"] !== "success") || (response["data"] === undefined)) {
    return { status: undefined, lastTime: undefined };
  }
  if ((response["data"]["result"] === undefined) || (response["data"]["result"].length <= 0)) {
    return { status: StatusType.Failure, lastTime: undefined };
  }
  const result = response["data"]["result"];
  for (let i = 0; i < result.length; i++) {
    const element = result[i];
    if ((element["metric"] !== undefined)
      && (element["metric"]["section"] === section)) {
      if ((element["values"] !== undefined)
        && (element["values"].length > 0)) {
        const values = element["values"];
        const lastValue = values[values.length - 1];
        const isNowOK = (lastValue[0] === endTime) && (lastValue[1] === "1");
        if (!isNowOK) {
          return { status: StatusType.Failure, lastTime: lastValue[0] };
        }
        let hasFailureInTheDuration = false;
        let expectedTime = startTime;
        for (let j = 0; j < values.length; j++) {
          const value = values[j];
          if ((expectedTime !== value[0]) || (value[1] !== "1")) {
            hasFailureInTheDuration = true;
            break;
          } else {
            expectedTime = expectedTime + 1;
          }
        }
        if (hasFailureInTheDuration) {
          return { status: StatusType.Recover, lastTime: endTime };
        } else {
          return { status: StatusType.Active, lastTime: endTime };
        }
      }
    }
  }
  return { status: StatusType.Failure, lastTime: undefined };
}
